export function getRandomColor() {
    const colorPool = ['#701414', '#F2A007', '#7A2DFA'];
    return colorPool[Math.floor(Math.random() * colorPool.length)];
}